export default "__VITE_PUBLIC_ASSET__e1765e09__"